import {get, post, put, destroy} from './config';

const Order = {
    getOrders: (status, page) =>
        get(`/v1/orders?status=${status}&page=${page}`),
    getOwnOrders: (params) =>
        post('/v1/orders/own/list', params),
    getOwnActiveOrders: (params = {}) =>
        get('/v1/orders/own/active', { params }),
    getOwnHistoryOrders: (params = {}) =>
        get('/v1/orders/own/history', { params }),
    getMarketplaceOrders: (params = {}) =>
        get(`/v1/orders/marketplace`, { params }),
    getMarketplaceAirOrders: (params = {}) =>
        get(`/v1/airorders/marketplace`, { params }),
    getOrderById: (orderId, lang) =>
        get(`v1/orders/by-${orderId}?lang=${lang}`),
    getAccount: (userId, summa) =>
        get(`/balance/${userId}?sum=${summa}`),
    create: (data) =>
        post('/v1/orders/create', data),
    createTender: (data) =>
        post('/v1/tender/create', data),
    newCreate: (data) =>
        post('/v1/orders/new-create', data),
    newUpdate: (orderId, data) =>
        put(`/v1/orders/new-update/${orderId}`, data),
    update: (orderId, data) =>
        put(`/v1/orders/update/${orderId}`, data),
    updateShippingDate: (orderId, data) =>
        put(`/v1/orders/update/shipping-date/${orderId}`, data),
    updateTender: (orderId, data) =>
        put(`/v1/tender/update/${orderId}`, data),
    getTenderPartners: (orderId) =>
        get(`/v1/tender/by-${orderId}`),
    createDraft: (data) =>
        post('/v1/orderdraft/create', data),
    updateDraft: (data, orderId) =>
        post(`/v1/orderdraft/update/${orderId}`, data),
    deleteDraftOrderById: (orderId) =>
        destroy(`/v1/orderdraft/${orderId}`),
    getDraftOrders: (params) =>
        get(`/v1/orderdraft/list`, { params }),
    deleteDraftOrders: () =>
        destroy(`/v1/orderdraft/all`),
    getDraftOrder: (order) =>
        get(`/v1/orderdraft/${order}`),
    getStatusWithOrderCounts: (companyId, data) =>
        get(`/v1/orders/own/active-count?companyId=${companyId}`, data),
    getOwnOrderQuantity: () =>
        get('/v1/orders/own/quantity'),
    getOwnOrderQuantityNew: (data) =>
        post(`/v1/orders/own/count`, data),
    getClientExportOrders: (data = {}) => 
        post('/v1/export/orders/client', data, { responseType: 'blob'}),
    getCompletedOrdersCount: (companyId, data) =>
        get(`/v1/orders/completed-orders-count?companyId=${companyId}`, data),
    getCancelList: () =>
        get('/v1/directories/order/cancelmessages'),
    canceled: (data) =>
        post('/v1/orders/canceled', data),
    deleteOrder: (orderId,user,reason) =>
        destroy(`v1/orders/${orderId}?username=${user}&reason=${reason}`),
    getCountries: (lang) =>
        get(`v1/directories/countries/${lang}`),
    getCountryById: (id) =>
        get(`v1/directories/countries/by-country-${id}`),
    getCities: (lang, countryId) =>
        get(`v1/directories/cities/${lang}/by-${countryId}`),
    getAllCities: (lang) =>
        get(`v1/directories/cities/all/${lang}`),
    getCityById: (id) =>
        get(`v1/directories/city/by-${id}`),
    getCategories: (lang) =>
        get(`v1/directories/cargo/categories/${lang}`),
    getTypes: () =>
        get('v1/directories/vehicle/types'),
    getWagonTypes: (lang) =>
        get(`/v1/directories/wagon-types/${lang}`),
    getCargo: (cargoId) =>
        get(`v1/orders/cargo/by-cargo-${cargoId}`),
    getActiveOrdersByExpeditor: (expeditorId, params) =>
        get(`v1/orders/expeditor/active-orders?expeditorId=${expeditorId}`, { params }), // params = &page={page}&limit={limit}
    getCompanyOrders: (companyId, params) =>
        get(`v1/orders/by-company/${companyId}`, { params }),
    getAllOrders: (status, countryIdFrom, cityIdFrom, shippingDate, countryIdTo, cityIdTo, cargoCategory, vehicleType, minWeight, maxWeight, page) =>
        get(`v1/orders/all?status=${status}&countryIdFrom=${countryIdFrom}&cityIdFrom=${cityIdFrom}&shippingDate=${shippingDate}&countryIdTo=${countryIdTo}&cityIdTo=${cityIdTo}&cargoCategory=${cargoCategory}&vehicleType=${vehicleType}&minWeight=${minWeight}&maxWeight=${maxWeight}&page=${page}`),
    getAllOrderList: (status, countryIdFrom, cityIdFrom, shippingDate, countryIdTo, cityIdTo, cargoCategory, vehicleType, minWeight, maxWeight, page, limit = 15, expeditorId) =>
        get(`v1/orders/list?status=${status}&page=${page}&limit=${limit}&countryIdFrom=${countryIdFrom}&cityIdFrom=${cityIdFrom}&shippingDate=${shippingDate}&countryIdTo=${countryIdTo}&cityIdTo=${cityIdTo}&cargoCategory=${cargoCategory}&vehicleType=${vehicleType}&minWeight=${minWeight}&maxWeight=${maxWeight}&expeditorId=${expeditorId}`),
    getAllOrdersQuantity: (status) =>
        get(`v1/orders/quantity/all?status=${status}`),
    getOrderPrice: (data) =>
        post('v1/algorithm/calculate', data),
    getLastPosition: (orderId, driverId) =>
        get(`v1/orders/positions/last?orderId=${orderId}&driverId=${driverId}`),
    getRecipient: (recipientId) =>
        get(`v1/orders/recipient/by-recipient-${recipientId}`),
    driverInfo: (userId) =>
        get(`v1/users/driver/info/${userId}`),
    getTemperaturesDisc: () =>
        get(`v1/directories/temperatures/`),
    getLoadingTypesDisc: (lang) =>
        get(`v1/directories/loading-types/${lang}`),
    getUserAddress: (params) =>
        get(`v1/useraddress/list`, { params }),
    getUserAddressCreate: (data) =>
        post(`v1/useraddress/create`, data),
    updateUserAddress: (addressId, data) =>
        put(`v1/useraddress/update/${addressId}`, data),
    deleteUserAddress: (addressId) =>
        destroy(`v1/useraddress/delete/${addressId}`),
    sendOrderBookPub: (orderId, data) =>
        post(`v1/orders/expeditor/book/${orderId}?vehicleId=${data.vehicleId}&driverId=${data.driverId}`, data), // ?vehicleId={vehicleId}&orderId={orderId}
    cancelOrderBook: (orderId, data) =>
        post(`v1/orders/expeditor/cancel-book/${orderId}`, data),
    getOrderForExpeditor: (params) => // params = { orderId: ID }
        get(`v1/orders/expeditor`, { params }),
    getAddYourCity: (data) =>
        post(`v1/directories/cities/from-client`, data),
    getCalculateOrderPrice: (cityIdFrom, cityIdTo) =>
        get(`v1/algorithm/calculate/check?cityIdFrom=${cityIdFrom}&cityIdTo=${cityIdTo}`),
    getListSuggestedPrice: (orderId) => 
        get(`/v1/orderbids/list?orderId=${orderId}&page=1&limit=100`),
    getComplexOrderBidList: (orderId) =>
        get(`/v1/complexorderbids/list?orderId=${orderId}`),
    confirmComplexOrderDistribution: (orderId, data) =>
        post(`/v1/complexorderbids/confirm-distribution/${orderId}`, data),
    acceptOrderBidById: (id, data) =>
        post(`/v1/orderbids/accepted/${id}`, data),
    decideNewPrice: (status, id, data) =>
        post(`/v1/orderbids/new-price/${id}/${status}`, data),
    updateStatus: (id, status, comment = '') =>
        post(`v1/orders/update-status/${id}/${status}`, { comment }),
    reassignExpeditor: (orderId, data) =>
        post(`/v1/orders/${orderId}/reassign-expeditor`, data),
    updateExpeditorStatus: (orderId, status, addressId) =>
        post(`v1/orders/expeditor/update-status/${orderId}?status=${status}&addressId=${addressId}`),
    saveWagonNumbers: (orderId, wagonNumbers) =>
        post(`/v1/orders/expeditor/${orderId}/wagon-number`, { wagonNumbers }),
    bookAirTransportOrder: (orderId, data) =>
        post(`v1/orders/saas/expeditor/book/airtransport/${orderId}`, data),
    getStatusWithOrderCountsForExpeditor: (data) =>
        post(`/v1/orders/expeditor/count`, data),
    bookUpdateStatus: (orderId, status, user) =>
      post(`v1/orders/update-status/${orderId}?status=${status}&username=${user}`),
    rejectConfirm: (orderId, status, user, reason) =>
      post(`v1/orders/reject-confirm/${status}/${orderId}?username=${user}&reason=${reason}`),
    getOrderViewById: (orderId) =>
        get(`v1/orderviews/${orderId}`),
    createOrderView: (orderId) =>
        post('/v1/orderviews', {orderId}),
    getOrderChat: (orderId) =>
        get(`/v1/orderchat/${orderId}`),
    sendMessage: (data) =>
        post(`/v1/orderchat`, data),
    getUnreadMessages: (orderId) =>
        get(`/v1/orderchat/unread/${orderId}`),
    readOrderChat: (id) =>
        put(`/v1/orderchat/read/${id}`),
    sendToMarketplace: (orderId, tenderDateEnd) =>
        post(`/v1/orders/send-marketplace/${orderId}?tenderDateEnd=${tenderDateEnd}`),
    extendTenderDateEnd: (id, tenderDateEnd) =>
        put(`/v1/tender/extend-tender-date-end/${id}?tenderDateEnd=${tenderDateEnd}`),
    rebidTender: (orderId, tenderDateEnd) =>
        put(`/v1/tender/rebid/${orderId}?tenderDateEnd=${encodeURIComponent(tenderDateEnd)}`),
    calculateInsuranceSum: (cargoPrice) =>
        get(`/v1/sabrinsurance/calculated-sum?cargoPrice=${cargoPrice}`),
    getTenderPartnersByOrder: (orderId) =>
        get(`/v1/tender/partners/by-order-${orderId}`),
    getSabrInsuranceStatus: (orderId, userType) =>
        get(`/v1/sabrinsurance/status?orderId=${orderId}&userType=${userType}`),
    insureExpeditorOrder: (orderId, data) =>
        post(`/v1/orders/expeditor/${orderId}/insurance`, data),
    updateReferenceNumber: (orderId, referenceNumber) =>
        put(`/v1/orders/reference-number/${orderId}`, { referenceNumber }),
    createOrderTrackingPoint: (orderId, location) =>
        post(`/v1/ordertrackingpoint/${orderId}`, { location }),
    getOrderTrackingPoints: (orderId) =>
        get(`/v1/ordertrackingpoint/${orderId}`),
}

export default Order;
